"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const commonUtils_1 = require("../commonUtils");
class ApiClient {
    client;
    token = null;
    timeout = 10000;
    createAxiosClient(apiConfiguration) {
        this.token = apiConfiguration.accessToken;
        return axios_1.default.create({
            baseURL: apiConfiguration.baseURL,
            responseType: 'json',
            headers: {
                'Content-Type': 'application/json',
                ...(apiConfiguration.accessToken && {
                    Authorization: `Bearer ${apiConfiguration.accessToken}`,
                }),
            },
            timeout: this.timeout,
        });
    }
    constructor(apiConfiguration) {
        this.client = this.createAxiosClient(apiConfiguration);
    }
    updateAccessToken(accessToken) {
        this.client.defaults.headers.Authorization = `Bearer ${accessToken}`;
        this.token = accessToken;
    }
    async post(path, payload, config) {
        try {
            const response = await this.client.post(path, payload, config);
            if (response.data.status) {
                // a bit of hackaroo to check if the type is already IResponse<T>
                return response.data;
            }
            return { status: 'success', data: response.data };
        }
        catch (error) {
            (0, commonUtils_1.spError)(error);
            return {
                status: 'error',
                message: error.message,
                data: error.response,
            };
        }
    }
    async patch(path, payload) {
        try {
            const response = await this.client.patch(path, payload);
            if (response.data.status) {
                // a bit of hackaroo to check if the type is already IResponse<T>
                return response.data;
            }
            return { status: 'success', data: response.data };
        }
        catch (error) {
            (0, commonUtils_1.spError)(error);
            return {
                status: 'error',
                message: error.message,
                data: error.response,
            };
        }
    }
    async put(path, payload) {
        try {
            const response = await this.client.put(path, payload);
            if (response.data.status) {
                // a bit of hackaroo to check if the type is already IResponse<T>
                return response.data;
            }
            return { status: 'success', data: response.data };
        }
        catch (error) {
            (0, commonUtils_1.spError)(error);
            return {
                status: 'error',
                message: error.message,
                data: error.response,
            };
        }
    }
    async get(path, config) {
        try {
            const response = await this.client.get(path, config);
            if (response.data.status) {
                // a bit of hackaroo to check if the type is already IResponse<T>
                return response.data;
            }
            return { status: 'success', data: response.data };
        }
        catch (error) {
            (0, commonUtils_1.spError)(error);
            return {
                status: 'error',
                message: error.message,
                data: error.response,
            };
        }
    }
    async delete(path, config) {
        try {
            const response = await this.client.delete(path, config);
            if (response.data.status) {
                // a bit of hackaroo to check if the type is already IResponse<T>
                return response.data;
            }
            return { status: 'success', data: response.data };
        }
        catch (error) {
            (0, commonUtils_1.spError)(error);
            return {
                status: 'error',
                message: error.message,
                data: error.response,
            };
        }
    }
    setInterceptors(responseInterceptor, responseInterceptorerror, requestInterceptor, requestInterceptorError) {
        this.client.interceptors.response.use(responseInterceptor, responseInterceptorerror);
        this.client.interceptors.request.use(requestInterceptor, requestInterceptorError);
    }
}
exports.default = ApiClient;
